import ManageAlerts from './ManageAlerts';
import SaveSearchButton from './SaveSearchButton';
import { IconWithTextWrapper } from '../SearchHeader.styles';

const SaveSearch = () => (
  <IconWithTextWrapper>
    <SaveSearchButton />
    <ManageAlerts />
  </IconWithTextWrapper>
);

export default SaveSearch;
